/* eslint-disable @typescript-eslint/no-unused-vars */
import { Datagrid, TextInput, TextField, useTranslate, SelectInput } from 'react-admin'
import UploadIcon from '@mui/icons-material/Upload'
import { ListBase } from '../../components/base'
import { COMMON_FIELDS, PRODUCTS_COMMON_FIELDS } from '../../providers/localization/constant'
import { ImportButton } from '../../components/buttons/ImportButton'

const CarsTireList = (): JSX.Element => {
  const translate = useTranslate()
  const carListFilters = [
    <TextInput key={0} source='brand' label={translate(`${PRODUCTS_COMMON_FIELDS}.brand.label`)} />,
    <TextInput key={1} source='model' label={translate(`${PRODUCTS_COMMON_FIELDS}.model.label`)} />,
    <TextInput key={2} source='sub_model' label={translate(`${PRODUCTS_COMMON_FIELDS}.sub_model.label`)} />,
    <TextInput key={3} source='year' label={translate(`${COMMON_FIELDS}.year`)} />,
    <TextInput key={4} source='tire_spec_height' label={translate(`${PRODUCTS_COMMON_FIELDS}.tire_spec_height.label`)} />,
    <TextInput key={5} source='tire_spec_width' label={translate(`${PRODUCTS_COMMON_FIELDS}.tire_spec_width.label`)} />,
    <TextInput key={6} source='tire_spec_diameter' label={translate(`${PRODUCTS_COMMON_FIELDS}.tire_spec_diameter.label`)} />,
  ]

  return (
    <ListBase
      listAction={{
        hasCreate: false,
        menuItems: [
          {
            label: `${PRODUCTS_COMMON_FIELDS}.import.title`,
            button: (
              <ImportButton
                label={translate(`${PRODUCTS_COMMON_FIELDS}.import.title`)}
                variant='contained'
                // ** todo import car **
                to={'/import-master-data/cars/tire'}
                key={19}
                icon={<UploadIcon />}
              />
            ),
            visible: true,
          },
        ],
      }}
      perPage={50}
      filters={carListFilters}
      sort={{ field: 'brand', order: 'asc' }}
    >
      <Datagrid rowClick={null} bulkActionButtons={null}>
        <TextField source='brand' label={`${PRODUCTS_COMMON_FIELDS}.brand.label`} />
        <TextField source='model' label={`${PRODUCTS_COMMON_FIELDS}.model.label`} />
        <TextField source='sub_model' label={`${PRODUCTS_COMMON_FIELDS}.sub_model.label`} />
        <TextField source='year' label={`${COMMON_FIELDS}.year`} />
        <TextField
          source='tire_spec_height'
          label={`${PRODUCTS_COMMON_FIELDS}.tire_spec_height.label`}
        />
        <TextField
          source='tire_spec_width'
          label={`${PRODUCTS_COMMON_FIELDS}.tire_spec_width.label`}
        />
        <TextField
          source='tire_spec_diameter'
          label={`${PRODUCTS_COMMON_FIELDS}.tire_spec_diameter.label`}
        />
      </Datagrid>
    </ListBase>
  )
}

export default CarsTireList
